module.exports = __webpack_public_path__ + "static/img/purchase-active.cb96d8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/purchase-active.png
// module id = 40C5
// module chunks = 58